import React, {useEffect, useState } from 'react';
import { ArrowLeft, Save, Plus, CheckCircle2 } from 'lucide-react';
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';

import { getSalesDetails, addSalesDetails, updateSalesDetails } from '../../redux/Sales/actions';
import { getAddressAPI } from '@/redux/Purchase/actions';
import { SearchBar } from '../SearchBox/SearchBar';
import FileUpload from '../FileUpload/FileUpload';
import { validateForm } from "../ui/useFormValidation";
import DatePicker from 'react-datepicker';
import { DataTable } from '../ui/table';
import { getItemColumns } from './columns';
import { showToast } from '@/redux/Toast/actions';
import CelebrationButton from '../ui/CelebrationButton/CelebrationButton';
import { callLoader } from '@/redux/Loader/actions';


const SalesOrderForm = ({ onBack, orderDataId = null }) => {

    const dispatch = useDispatch();
    const [formData, setFormData] = useState();
    const [items, setItems] = useState([]);

    const [authUser] = JSON.parse(localStorage.getItem('authUser') ?? "[{}]");
    const userName = authUser?.username;
    const companyId=authUser?.companyId;


    const {countryList,  incoTermsList, quantityTypeList, uomTypeList } = useSelector((state) => state.common);
    const [errors, setErrors] = useState({});
        const { isAnimate } = useSelector((state) => state.toast);

    useEffect(() => {
        if (orderDataId != 0 && orderDataId != null) {
            _getSalesOrder();
        } else {
            _setNewSalesOrder();
        }
    }, [orderDataId])

    const _getSalesOrder = async () => {
       try {
            dispatch(callLoader(1));
         const resultData = await dispatch(getSalesDetails(orderDataId));
        console.log(resultData);
        setFormData(resultData);
        setItems(resultData?.lineItems ?? []);
    dispatch(callLoader(0));
        console.log(moment(resultData?.poDate).format('YYYY-MM-DD'));
       } catch (error) {
            dispatch(callLoader(0));
       }
    }

    const _setNewSalesOrder = async () => {
        setFormData(null);
        setItems([{
            salesOrderLineItemId: 0,
            sku: '',
            skuItemDesc: '',
            uot: 0,
            casesPerUot: 0,
            remainingUnit: 0,
            remainingCases: 0,
            caseCount: 0,
            caseCountUOM: '',
            packing: '0.00',
            quantity: '0.00',
            metricId: 0,
            metricType: '',
            price: 0,
            total: 0,
            warehouse: '',
            notes: ''
        }])
    }

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleItemChange = (index, field, value) => {
        const updated = [...items];
        updated[index][field] = value;

        if (field === 'quantity' || field === 'price') {
            const qty = parseFloat(updated[index].quantity) || 0;
            const price = parseFloat(updated[index].price) || 0;
            updated[index].total = (qty * price).toFixed(2);
        }

        setItems(updated);
    };

    const addItem = () => {
        setItems([...items, {
            id: items.length + 1,
            sno: items.length + 1,
            skuCode: '',
            itemDesc: '',
            uot: '0.00',
            casesPerUot: '0.00',
            remainingUnit: '',
            remainingCases: '',
            caseCount: '0.00',
            uomcd: 'SELECT UOMCD',
            packing: '0.00',
            quantity: '0.00',
            unit: 'TON',
            price: '0.00',
            total: '0.00',
            source: 'Manual',
            notes: ''
        }]);
    };

    const removeItem = (index) => {
        if (items.length > 1) {
            setItems(items.filter((_, i) => i !== index));
        }
    };

    const _setAddress = async (type, id) => {
        const address = await getAddressAPI(id);
        setFormData(prev => ({ ...prev, [`${type}`]: address }));
    };


    const validationConfig = {

        soNumber: { required: true, label: "Sales Order" },
        customerId: { required: true, label: "Customer" },
        payTerms: { required: true, label: "Pay Terms" },
        documentTo: { required: true, label: "Document To" },
        warehouseId: { required: true, label: "Warehouse" },
        warehouseAddress: { required: true, label: "Warehouse Address" },


        pol: { required: true, label: "POL" },
        destination: { required: true, label: "Destination" },
        pod: { required: true, label: "POD" },
        destinationCountry: { required: false },


        soDate: { required: true, label: "SO Date" },
        shipByDate: { required: true, label: "Ship By Date" },


        remarks: { required: false },
        incotermId: { required: false },
        salesPersonId: { required: false },
    };


    const handleSubmit = async (e) => {
        try {

            var itmPayload = [];
            items.map((v, i) => {
                const ob = {
                    "salesorder_lineitem_ID": v?.salesOrderLineItemId ?? 0,
                    "sku": v?.sku,
                    "sku_item_desc": v?.skuItemDesc,
                    "uot": v?.uot,
                    "cases_per_uot": v?.casesPerUot,
                    "remaining_unit": v?.remainingUnit,
                    "remaining_cases": v?.remainingCases,
                    "uom_type_ID": v?.uomTypeId,
                    "uom_type": v?.uomType,
                    "packing": v?.packing,
                    "quantity": v?.quantity,
                    "metric_ID": v?.metricId,
                    "metric_type": v?.metricType,
                    "price": v?.price,
                    "source": v?.source,
                    "notes": v?.notes,
                    "load_status": v?.loadStatus,
                    "created_by": v?.createdBy ?? userName,
                    "is_active": v?.isActive != false ? true : false,
                }
                itmPayload.push(ob);
            });
            const payload = {
                "so_ID": orderDataId ?? 0,
                "company_ID": companyId,
                "warehouse_ID": formData?.warehouseId,
                "warehouse": formData?.warehouse,
                "warehouse_address": formData?.warehouseAddress,
                "pol": formData?.pol,
                "pod": formData?.pod,
                "destination": formData?.destination,
                "document_to": formData?.documentTo,
                "so_date": formData?.soDate,
                "ship_by_date": formData?.shipByDate,
                "customer_ID": formData?.customerId,
                "customer": formData?.customer,
                "customer_address": formData?.customerAddress,
                "pay_terms": formData?.payTerms,
                "incoterm_ID": formData?.incotermId,
                "incoterm": formData?.incoterm,
                "destination_country": formData?.destinationCountry,
                "assign_to_ID": formData?.assignToId,
                "assign_to_name": formData?.assignToName,
                "sales_person_ID": formData?.salesPersonId,
                "sales_person": formData?.salesPerson,
                "remarks": formData?.remarks,
                "created_by": formData?.createdBy ?? userName, //formData?.createdBy ?? "admin",
                "ar_hold": formData?.arHold,
                "is_active": formData?.isActive != false ? true : false,
                "lineItems": itmPayload
            }

    

            const validationErrors = validateForm({
                data: formData,
                items,
                rules: validationConfig,
            });

            setErrors(validationErrors);

            if (Object.keys(validationErrors).length > 0) {
                return;
            }
    dispatch(callLoader(1));
            if (orderDataId != 0 && orderDataId != null) {
                const updateDetails = await updateSalesDetails(payload);
                console.log(updateDetails);
            } else {
                const addDetails = await addSalesDetails(payload);
                console.log(addDetails);
            }
            // window.location.reload();
               dispatch(callLoader(0));
               dispatch(showToast("Record saved successfully", "success", true))

        } catch (e) {
            console.log('Error in submitting sales order:', e);
                dispatch(showToast("Error in submitting sales order", "error"))
               dispatch(callLoader(0));
        }
    }

    const formhandleSubmit = async (e) => {
        e.preventDefault();
    }

   const columns = getItemColumns({
  items,
  handleItemChange,
  uomTypeList,
  quantityTypeList,
});

 const options = (countryList || [])?.map((loc) => {
    const match = (loc?.incoterm || "").match(/\(([^)]+)\)/);
    const code = match ? match[1] : null;
    return {
      value: code,
      label: loc?.incoterm,
    };
  });

    return (
      <div className="h-full bg-slate-50 dark:bg-slate-950 overflow-y-auto">
        <div className="w-full px-6 py-6">
          {/* Compact Header */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <button
                onClick={onBack}
                className="p-2 hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg transition-colors"
              >
                <ArrowLeft className="w-5 h-5 text-slate-600 dark:text-slate-400" />
              </button>
              <div>
                <h1 className="text-xl font-bold text-slate-900 dark:text-white">
                  {orderDataId ? "Edit Sales Order" : "New Sales Order"}
                </h1>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  {orderDataId
                    ? `Editing ${orderDataId}`
                    : "Create a new order"}
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <button
                type="button"
                onClick={onBack}
                className="px-4 py-2 text-sm text-slate-600 dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg transition-all"
              >
                Cancel
              </button>
              <CelebrationButton
                onClick={() => handleSubmit()}
                label={"Save Plan"}
                className="px-4 py-2 text-sm bg-[#0072FF] hover:bg-[#0062DD] text-white rounded-lg font-medium transition-all flex items-center space-x-1"
                icon={<Save className="w-4 h-4" />}
                isSuccess={isAnimate}
              />
            </div>
          </div>

          <form id="so-form" onSubmit={formhandleSubmit} className="space-y-4">
            {/* Order Details Section */}
            <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 p-4">
              <h2 className="text-sm font-semibold text-slate-900 dark:text-white mb-3">
                Order Details
              </h2>
              <div className="grid grid-cols-3 gap-4">
                {/* Column 1 */}
                <div className="space-y-3">
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Sales Order #:<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="salesOrderNo"
                      value={formData?.soNumber}
                      onChange={handleInputChange}
                      readOnly
                      required="required"
                      className={`w-full px-3 py-2 text-sm  rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]
                                             ${errors.soNumber ? "border border-red-500" : "border border-slate-300 dark:border-slate-700"}`}
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Inco Terms:
                    </label>
                    <select
                      name="incotermId"
                      value={formData?.incotermId}
                      onChange={(e) => {
                        handleInputChange({
                          target: { name: "incotermId", value: e.target.value },
                        });
                        handleInputChange({
                          target: {
                            name: "incoterm",
                            value:
                              e.target.options[e.target.selectedIndex].text,
                          },
                        });
                      }}
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                    >
                      <option value="">SELECT</option>
                      {incoTermsList?.map((term, key) => (
                        <option key={key} value={term?.id}>
                          {term?.incoterm}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Sales Person:
                    </label>
                    <SearchBar
                      searchAPI={
                        "v1/AutoSuggestion/GetVendorSuggestion?Prefix="
                      }
                      selectReacord={(d) => {
                        handleInputChange({
                          target: { name: "salesPerson", value: d?.[1] },
                        });
                        handleInputChange({
                          target: { name: "salesPersonId", value: d?.[0] },
                        });
                      }}
                      value={formData?.salesPerson}
                    />
                  </div>
                  {/* <div>
                                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                                        Assign To:
                                    </label>
                                    <select
                                        name="assignTo"
                                        value={formData?.assignTo}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                                    >
                                        <option value="">SELECT SALES PERSON</option>
                                        <option>John Doe</option>
                                        <option>Jane Smith</option>
                                        <option>Mike Johnson</option>
                                    </select>
                                </div> */}
                </div>
                {/* Column 2 */}
                <div className="space-y-3">
                  <div>
                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400 mb-1 flex items-center space-x-2">
                      <span>
                        Customer:<span className="text-red-500">*</span>
                      </span>
                      <CheckCircle2 className="w-4 h-4 text-green-500" />
                    </label>
                    <SearchBar
                      searchAPI={
                        "v1/AutoSuggestion/GetCustomerSuggestion?Prefix="
                      }
                      selectReacord={(d) => {
                        handleInputChange({
                          target: { name: "customer", value: d?.[1] },
                        });
                        handleInputChange({
                          target: { name: "customerId", value: d?.[0] },
                        });
                        _setAddress("customerAddress", d?.[0]);
                      }}
                      value={formData?.customer}
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Pay Terms:<span className="text-red-500">*</span>
                    </label>
                    <select
                      name="payTerms"
                      value={formData?.payTerms}
                      onChange={handleInputChange}
                      required
                      className={`w-full px-3 py-2 text-sm rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] 
                                            ${errors.payTerms ? "border border-red-500" : "border border-slate-300"} `}
                    >
                      <option value="">SELECT PAY TERMS</option>
                      <option value="NET30">Net 30</option>
                      <option value="NET60">Net 60</option>
                      <option value="NET90">Net 90</option>
                      <option value="COD">Cash on Delivery</option>
                      <option value="PREPAID">Prepaid</option>
                      <option value="DUE_ON_RECEIPT">Due on Receipt</option>
                    </select>
                    {/* {errors.payTerms && (
                                        <p className="text-xs text-red-500 mt-1">{errors.payTerms}</p>
                                    )} */}
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Document To:<span className="text-red-500">*</span>
                    </label>
                    <SearchBar
                      searchAPI={
                        "v1/AutoSuggestion/GetVendorSuggestion?Prefix="
                      }
                      selectReacord={(d) => {
                        handleInputChange({
                          target: { name: "documentTo", value: d?.[1] },
                        });
                      }}
                      value={formData?.documentTo}
                    />
                  </div>
                  <div className="flex items-center space-x-2 justify-end">
                    <input
                      type="checkbox"
                      name="arHold"
                      checked={formData?.arHold}
                      onChange={handleInputChange}
                      className="rounded border-slate-300 text-blue-500 focus:ring-blue-500"
                    />
                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                      AR Hold:
                    </label>
                  </div>
                </div>
                {/* Column 3 */}
                <div className="space-y-3">
                  <div>
                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400 mb-1 flex items-center space-x-2">
                      <span>
                        Warehouse:<span className="text-red-500">*</span>
                      </span>
                      <CheckCircle2 className="w-4 h-4 text-green-500" />
                    </label>
                    <SearchBar
                      searchAPI={
                        "v1/AutoSuggestion/GetWarehouseSuggestion?Prefix="
                      }
                      selectReacord={(d) => {
                        handleInputChange({
                          target: { name: "warehouse", value: d?.[1] },
                        });
                        handleInputChange({
                          target: { name: "warehouseId", value: d?.[0] },
                        });
                        _setAddress("warehouseAddress", d?.[0]);
                      }}
                      value={formData?.warehouse}
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Warehouse Address:<span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="warehouseAddress"
                      value={formData?.warehouseAddress}
                      onChange={handleInputChange}
                      required
                      rows="3"
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] resize-none"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Remarks:
                    </label>
                    <textarea
                      name="remarks"
                      value={formData?.remarks}
                      onChange={handleInputChange}
                      rows="3"
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] resize-none"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 p-4">
              <h2 className="text-sm font-semibold text-slate-900 dark:text-white mb-3">
                Routing
              </h2>
              <div className="grid grid-cols-3 gap-6">
                <div>
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Pol:<span className="text-red-500">*</span>
                  </label>
                  <SearchBar
                    searchAPI={
                      "v1/AutoSuggestion/GetDestinationSuggestion?Prefix="
                    }
                    selectReacord={(d) => {
                      handleInputChange({
                        target: { name: "pol", value: d?.[1] },
                      });
                    }}
                    value={formData?.pol}
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Destination:<span className="text-red-500">*</span>
                  </label>
                  <SearchBar
                    searchAPI={
                      "v1/AutoSuggestion/GetDestinationSuggestion?Prefix="
                    }
                    selectReacord={(d) => {
                      handleInputChange({
                        target: { name: "destination", value: d?.[1] },
                      });
                    }}
                    value={formData?.destination}
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Dest. Country:
                  </label>
                  <select
                    name="destinationCountry"
                    value={formData?.destinationCountry}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                  >
                    <option value="">SELECT COUNTRY OF DESTINATION</option>
                    {options &&
                      (options || []).map((item) => (
                        <option value={item?.value}>{item?.label}</option>
                      ))}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Pod:<span className="text-red-500">*</span>
                  </label>
                  <SearchBar
                    searchAPI={
                      "v1/AutoSuggestion/GetDestinationSuggestion?Prefix="
                    }
                    selectReacord={(d) => {
                      handleInputChange({
                        target: { name: "pod", value: d?.[1] },
                      });
                    }}
                    value={formData?.pod}
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Date:
                  </label>

                  <DatePicker
                    selected={
                      formData?.soDate ? new Date(formData.soDate) : null
                    }
                    showIcon
                    onChange={(date) =>
                      handleInputChange({
                        target: {
                          name: "soDate",
                          value: moment(date).format("YYYY-MM-DD"),
                        },
                      })
                    }
                    dateFormat="dd MMM yyyy"
                    placeholderText="Select Date"
                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Ship by Date:
                  </label>
                  <DatePicker
                    selected={
                      formData?.shipByDate
                        ? new Date(formData.shipByDate)
                        : null
                    }
                    showIcon
                    onChange={(date) =>
                      handleInputChange({
                        target: {
                          name: "shipByDate",
                          value: moment(date).format("YYYY-MM-DD"),
                        },
                      })
                    }
                    dateFormat="dd MMM yyyy"
                    placeholderText="Select Date"
                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                  />
                </div>
              </div>
            </div>

            {/* Commodity Table */}
            <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800">
              <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 dark:border-slate-800">
                <h2 className="text-sm font-semibold text-slate-900 dark:text-white">
                  Commodity
                </h2>
                <button
                  type="button"
                  onClick={addItem}
                  className="px-3 py-1 text-xs bg-[#0072FF] hover:bg-[#0062DD] text-white rounded-lg font-medium transition-all flex items-center space-x-1"
                >
                  <Plus className="w-3 h-3" />
                  <span>Add More Row</span>
                </button>
              </div>

              <DataTable
                data={items.filter((i) => i?.isActive !== false)}
                columns={columns}
                tdClass="px-2 py-2"
                thClass="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400"
                trClass="hover:bg-slate-50 dark:hover:bg-slate-800/30"
                htrClass="border-b border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50"
                boxClass="overflow-x-auto overflow-y-visible pb-[20vh] text-xs"
              />
            </div>

            {/* Upload Documents Section */}
            {orderDataId != 0 && orderDataId != null && (
              <>
                <FileUpload
                  orderId={orderDataId}
                  orderNum={formData?.soNumber}
                  type={"sales"}
                />
              </>
            )}
          </form>
        </div>
      </div>
    );
};

export default SalesOrderForm;
